import React from "react";
import Context from "./context.js";
import axios from "axios";
import Cookies from "universal-cookie";
import host from "./host";

const cookies = new Cookies();

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      phone: "",
      password: "",
      error: "",
      showPassword: false,
    };
  }

  async submit() {
    const { phone, password } = this.state;
    
    if (!phone || !password) {
      this.setState({ error: "يرجى ملء جميع الحقول" });
      return;
    }

    try {
      this.setState({ loading: true, error: "" });

      const response = await axios.post(host + "users/auth/login", {
        phone: phone,
        password: password,
        ip: "ip",
      });

      cookies.set("token", response.data.data.token, {
        path: "/",
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      });

      window.location.href = "/";
    } catch (error) {
      this.setState({ 
        error: error.response?.data?.message || "فشل تسجيل الدخول، يرجى المحاولة مرة أخرى" 
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.submit();
    }
  };

  render() {
    const { loading, phone, password, error, showPassword } = this.state;

    return (
      <Context.Consumer>
        {(ctx) => (
          <>
            <style>{`
              @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700&display=swap');
              
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }

              .login-container {
                min-height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 20px;
                font-family: 'Tajawal', sans-serif;
                direction: rtl;
                background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
                position: relative;
                overflow: hidden;
              }

              .login-container::before {
                content: '';
                position: absolute;
                top: -50%;
                left: -50%;
                width: 200%;
                height: 200%;
                background: radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 50%);
                animation: pulse 15s ease-in-out infinite;
              }

              @keyframes pulse {
                0%, 100% { transform: scale(1) rotate(0deg); }
                50% { transform: scale(1.1) rotate(180deg); }
              }

              .floating-shapes {
                position: absolute;
                width: 100%;
                height: 100%;
                overflow: hidden;
                pointer-events: none;
              }

              .shape {
                position: absolute;
                background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2));
                border-radius: 50%;
                animation: float 20s ease-in-out infinite;
              }

              .shape:nth-child(1) {
                width: 80px;
                height: 80px;
                top: 10%;
                left: 10%;
                animation-delay: 0s;
              }

              .shape:nth-child(2) {
                width: 120px;
                height: 120px;
                top: 70%;
                right: 10%;
                animation-delay: -5s;
              }

              .shape:nth-child(3) {
                width: 60px;
                height: 60px;
                bottom: 20%;
                left: 20%;
                animation-delay: -10s;
              }

              @keyframes float {
                0%, 100% { transform: translateY(0) rotate(0deg); opacity: 0.5; }
                50% { transform: translateY(-30px) rotate(180deg); opacity: 0.8; }
              }

              .login-card {
                background: rgba(255, 255, 255, 0.95);
                backdrop-filter: blur(20px);
                border-radius: 24px;
                padding: 40px 32px;
                width: 100%;
                max-width: 420px;
                box-shadow: 
                  0 25px 50px -12px rgba(0, 0, 0, 0.4),
                  0 0 0 1px rgba(255, 255, 255, 0.1);
                position: relative;
                z-index: 10;
                animation: slideUp 0.6s ease-out;
              }

              @keyframes slideUp {
                from {
                  opacity: 0;
                  transform: translateY(30px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              .logo-container {
                text-align: center;
                margin-bottom: 32px;
              }

              .logo-icon {
                width: 80px;
                height: 80px;
                background: linear-gradient(135deg, #6366f1, #8b5cf6);
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto 16px;
                box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);
              }

              .logo-icon svg {
                width: 40px;
                height: 40px;
                color: white;
              }

              .login-title {
                font-size: 28px;
                font-weight: 700;
                color: #1a1a2e;
                margin-bottom: 8px;
              }

              .login-subtitle {
                font-size: 15px;
                color: #64748b;
              }

              .form-group {
                margin-bottom: 20px;
                position: relative;
              }

              .form-label {
                display: block;
                font-size: 14px;
                font-weight: 500;
                color: #374151;
                margin-bottom: 8px;
              }

              .input-wrapper {
                position: relative;
              }

              .input-icon {
                position: absolute;
                right: 16px;
                top: 50%;
                transform: translateY(-50%);
                color: #9ca3af;
                pointer-events: none;
                transition: color 0.3s;
              }

              .form-input {
                width: 100%;
                padding: 14px 48px 14px 16px;
                font-size: 16px;
                font-family: 'Tajawal', sans-serif;
                border: 2px solid #e5e7eb;
                border-radius: 12px;
                background: #f9fafb;
                color: #1a1a2e;
                transition: all 0.3s ease;
                direction: rtl;
              }

              .form-input::placeholder {
                color: #9ca3af;
              }

              .form-input:focus {
                outline: none;
                border-color: #6366f1;
                background: white;
                box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
              }

              .form-input:focus + .input-icon,
              .form-input:not(:placeholder-shown) + .input-icon {
                color: #6366f1;
              }

              .password-toggle {
                position: absolute;
                left: 16px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                color: #9ca3af;
                cursor: pointer;
                padding: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: color 0.3s;
              }

              .password-toggle:hover {
                color: #6366f1;
              }

              .error-message {
                background: #fef2f2;
                border: 1px solid #fecaca;
                color: #dc2626;
                padding: 12px 16px;
                border-radius: 10px;
                font-size: 14px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                gap: 8px;
                animation: shake 0.5s ease-in-out;
              }

              @keyframes shake {
                0%, 100% { transform: translateX(0); }
                25% { transform: translateX(-5px); }
                75% { transform: translateX(5px); }
              }

              .submit-btn {
                width: 100%;
                padding: 16px;
                font-size: 17px;
                font-weight: 600;
                font-family: 'Tajawal', sans-serif;
                color: white;
                background: linear-gradient(135deg, #6366f1, #8b5cf6);
                border: none;
                border-radius: 12px;
                cursor: pointer;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                position: relative;
                overflow: hidden;
              }

              .submit-btn::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                transition: left 0.5s ease;
              }

              .submit-btn:hover:not(:disabled)::before {
                left: 100%;
              }

              .submit-btn:hover:not(:disabled) {
                transform: translateY(-2px);
                box-shadow: 0 10px 30px rgba(99, 102, 241, 0.4);
              }

              .submit-btn:active:not(:disabled) {
                transform: translateY(0);
              }

              .submit-btn:disabled {
                background: linear-gradient(135deg, #9ca3af, #6b7280);
                cursor: not-allowed;
              }

              .spinner {
                width: 20px;
                height: 20px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                border-top-color: white;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
              }

              @keyframes spin {
                to { transform: rotate(360deg); }
              }

              .divider {
                display: flex;
                align-items: center;
                margin: 24px 0;
                gap: 16px;
              }

              .divider-line {
                flex: 1;
                height: 1px;
                background: #e5e7eb;
              }

              .divider-text {
                font-size: 13px;
                color: #9ca3af;
              }

              .footer-text {
                text-align: center;
                font-size: 14px;
                color: #64748b;
                margin-top: 24px;
              }

              .footer-link {
                color: #6366f1;
                font-weight: 600;
                text-decoration: none;
                transition: color 0.3s;
              }

              .footer-link:hover {
                color: #8b5cf6;
              }

              @media (max-width: 480px) {
                .login-card {
                  padding: 32px 24px;
                  border-radius: 20px;
                }

                .logo-icon {
                  width: 70px;
                  height: 70px;
                }

                .login-title {
                  font-size: 24px;
                }

                .form-input {
                  padding: 12px 44px 12px 14px;
                  font-size: 15px;
                }

                .submit-btn {
                  padding: 14px;
                  font-size: 16px;
                }
              }
            `}</style>

            <div className="login-container">
              <div className="floating-shapes">
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
              </div>

              <div className="login-card">
                <div className="logo-container">
                  <div className="logo-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                      <polyline points="10 17 15 12 10 7" />
                      <line x1="15" y1="12" x2="3" y2="12" />
                    </svg>
                  </div>
                  <h1 className="login-title">مرحباً بك</h1>
                  <p className="login-subtitle">سجّل دخولك للمتابعة</p>
                </div>

                {error && (
                  <div className="error-message">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {error}
                  </div>
                )}

                <div className="form-group">
                  <label className="form-label">رقم الهاتف</label>
                  <div className="input-wrapper">
                    <input
                      type="tel"
                      className="form-input"
                      placeholder="أدخل رقم الهاتف"
                      value={phone}
                      onChange={(e) => this.setState({ phone: e.target.value, error: "" })}
                      onKeyPress={this.handleKeyPress}
                    />
                    <span className="input-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                      </svg>
                    </span>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">كلمة المرور</label>
                  <div className="input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-input"
                      placeholder="أدخل كلمة المرور"
                      value={password}
                      onChange={(e) => this.setState({ password: e.target.value, error: "" })}
                      onKeyPress={this.handleKeyPress}
                    />
                    <span className="input-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => this.setState({ showPassword: !showPassword })}
                    >
                      {showPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <button
                  className="submit-btn"
                  onClick={() => this.submit()}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      جارٍ التحقق...
                    </>
                  ) : (
                    <>
                      تسجيل الدخول
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="19" y1="12" x2="5" y2="12" />
                        <polyline points="12 19 5 12 12 5" />
                      </svg>
                    </>
                  )}
                </button>

                <div className="divider">
                  <span className="divider-line"></span>
                  <span className="divider-line"></span>
                </div>


              </div>
            </div>
          </>
        )}
      </Context.Consumer>
    );
  }
}

export default Login;